'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n'], ['\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: 1px solid black;\n  background: lightgray;\n  font-size: 6rem;\n  padding: 0.6rem;\n  margin: 0.6rem;\n  text-align: center;\n  @media (max-width: 1024px) {\n    font-size: 4rem;\n    padding: 0.4rem;\n    margin: 0.4rem;\n  }\n  @media (max-width: 480px) {\n    font-size: 2rem;\n    padding: 0.2rem;\n    margin: 0.2rem;\n  }\n'], ['\n  border: 1px solid black;\n  background: lightgray;\n  font-size: 6rem;\n  padding: 0.6rem;\n  margin: 0.6rem;\n  text-align: center;\n  @media (max-width: 1024px) {\n    font-size: 4rem;\n    padding: 0.4rem;\n    margin: 0.4rem;\n  }\n  @media (max-width: 480px) {\n    font-size: 2rem;\n    padding: 0.2rem;\n    margin: 0.2rem;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 1rem;\n  text-align: center;\n  @media (max-width: 480px) {\n    font-size: 0.5rem;\n  }\n'], ['\n  font-size: 1rem;\n  text-align: center;\n  @media (max-width: 480px) {\n    font-size: 0.5rem;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MS_PER_DAY = 86400000;
var MS_PER_HOUR = 3600000;
var MS_PER_MINUTE = 60000;
var MS_PER_SECOND = 1000;

var Panel = _styledComponents2.default.div(_templateObject);

var Cell = _styledComponents2.default.div(_templateObject2);

var Label = _styledComponents2.default.div(_templateObject3);

/** @function zeroPad
  * A helper function to pad number strings with
  * leading zeroes.
  * @param {integer} num - the number to pad
  * @param {integer} digits - the number of digits in the padded number
  * @returns {string} The padded number as a string.
  */
function zeroPad(num, digits) {
  var str = num.toString();
  for (var i = digits - str.length; i > 0; i--) {
    str = "0" + str;
  }return str;
}

/** @class Clock
  * A countdown timer implementation.
  */

var Clock = function (_Component) {
  _inherits(Clock, _Component);

  function Clock(props) {
    _classCallCheck(this, Clock);

    var _this = _possibleConstructorReturn(this, (Clock.__proto__ || Object.getPrototypeOf(Clock)).call(this, props));

    _this.state = {
      time: props.opens - Date.now()
    };
    return _this;
  }

  _createClass(Clock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = window.setInterval(function () {
        var time = _this2.props.opens - Date.now();
        if (time < 0) _this2.props.onOpen();else _this2.setState({ time: _this2.props.opens - Date.now() });
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.clearInterval(this.interval);
    }
  }, {
    key: 'render',
    value: function render() {
      // calculate time values
      var time = this.state.time;
      var days = Math.floor(time / MS_PER_DAY);
      time %= MS_PER_DAY;
      var hours = Math.floor(time / MS_PER_HOUR);
      time %= MS_PER_HOUR;
      var minutes = Math.floor(time / MS_PER_MINUTE);
      time %= MS_PER_MINUTE;
      var seconds = Math.floor(time / MS_PER_SECOND);

      return _react2.default.createElement(
        Panel,
        null,
        _react2.default.createElement(
          Cell,
          null,
          zeroPad(days, 3),
          _react2.default.createElement(
            Label,
            null,
            'DAYS'
          )
        ),
        _react2.default.createElement(
          Cell,
          null,
          zeroPad(hours, 2),
          _react2.default.createElement(
            Label,
            null,
            'HOURS'
          )
        ),
        _react2.default.createElement(
          Cell,
          null,
          zeroPad(minutes, 2),
          _react2.default.createElement(
            Label,
            null,
            'MINS'
          )
        ),
        _react2.default.createElement(
          Cell,
          null,
          zeroPad(seconds, 2),
          _react2.default.createElement(
            Label,
            null,
            'SECS'
          )
        )
      );
    }
  }]);

  return Clock;
}(_react.Component);

exports.default = Clock;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/countdown/clock.js
// module id = 680
// module chunks = 0